<script setup>
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
const { question, disabled } = defineProps({ question: Object, disabled: Boolean });
const modelValue = defineModel();

watch(
    () => question.answer,
    (newAnswer) => {
        modelValue.value = newAnswer;
    },
    { immediate: true, deep: true }
);
</script>
<template>
    <div class="input-wrapper">
        <label class="input-label">{{ t('tests.answerInput') }}:</label>
        <InputText
            v-model="modelValue"
            fluid
            size="large"
            :disabled="disabled"
            :class="{
                'p-invalid': question.isCorrect == false,
                'p-valid': question.isCorrect == true,
            }"
        />
        <p class="input-correct" v-if="question.correctAnswer">
            {{ t('tests.correctAnswer') }}: <span>{{ question.correctAnswer }}</span>
        </p>
    </div>
</template>
<style scoped>
.input-wrapper {
    @apply flex flex-col gap-2 w-full;
}
.input-label {
    @apply text-lg text-black;
}
.p-invalid {
    @apply border-red-500 !bg-red-100 !text-red-500;
}
.p-valid {
    @apply border-green-500 !bg-green-100 !text-green-500;
}
.input-correct {
    @apply text-lg text-black font-bold mt-2;
}
.input-correct span {
    @apply text-green-500;
}
</style>
